import { gsap } from 'gsap';
import { animationTrigger } from '../common';

export function initWhatDoes() {
  const parent = document.querySelector('.js-what-does');
  if (!parent) return;

  const card = parent.querySelector('.what-does__penetration');

  setTimeout(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: animationTrigger,
        end: 'top+=50% 80%',
        toggleActions: 'play play reverse reverse',
        // markers: true,
      },
    });

    tl.fromTo(
      card,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
      },
    );
  }, 200);
}
